var _circle, _path, _circle2, _path2, _circle3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSaleCenter = function SvgSaleCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.47059,
    cy: 7.52918,
    r: 2.47059
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4705 7.88184L27.9999 7.88184",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.47059,
    cy: 15.9999,
    r: 2.47059
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4705 16.3525L27.9999 16.3525",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.47059,
    cy: 24.4706,
    r: 2.47059
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4705 24.8232L27.9999 24.8232",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
export default SvgSaleCenter;